<flx-branch-name
  [branchName]="$safeNavigationMigration(app()?.branchName)"
  [branchOrder]="$safeNavigationMigration(app()?.branchOrder)"
/>
@if (app()?.status !== 'WIP') {
  {{ app().commitMessage }}
} @else {
  <flx-branch-state [status]="app().status" />
}
